/**
 * old-radial-to-Orbit mapping (legacy canvas radial → Phase 4 Orbit):
 * Copy → Duplicate; Paste → New node; Duplicate → Duplicate; Cut → Delete;
 * Bring to front / Send to back / Lock / Unlock / Select all / Undo / Redo → Edit;
 * Delete → Delete. The former radial's actions remain toast-only until the Phase 3 follow-up.
 */
import type { OrbitSlice } from '../Common/Orbit/orbitTypes'
import { datasetId, slice, targetlessSlice, type OrbitActionBridge } from '../Common/Orbit/orbitSliceHelpers'
import { ChangeRoleIcon, CycleRoleIcon, DeleteIcon, DetachIcon, DuplicateIcon, EditIcon, NewNodeIcon, ReflowIcon, ShowAllBindingsIcon, ShowDownstreamIcon } from '../Common/Orbit/icons'

export type DesignOrbitAction = OrbitActionBridge
const nodeId = (node: HTMLElement) => datasetId(node, 'nodeId', 'roleId')
// TODO(orbit-phase-6): re-add "Show materializations" once we drop a slice or bump the clamp.
export const buildDesignNodeSlices = (node: HTMLElement, action: DesignOrbitAction): OrbitSlice[] => [
  slice('node-edit', 'Edit', EditIcon, action, node, nodeId),
  slice('node-duplicate', 'Duplicate', DuplicateIcon, action, node, nodeId),
  slice('node-change-role', 'Change role', ChangeRoleIcon, action, node, nodeId),
  slice('node-delete', 'Delete', DeleteIcon, action, node, nodeId),
]
export const buildRoleBadgeSlices = (node: HTMLElement, action: DesignOrbitAction): OrbitSlice[] => [
  slice('role-cycle', 'Cycle role', CycleRoleIcon, action, node, nodeId),
  slice('role-downstream', 'Show downstream', ShowDownstreamIcon, action, node, nodeId, true),
  slice('role-detach', 'Detach', DetachIcon, action, node, nodeId),
]
export const buildDesignCanvasSlices = (action: DesignOrbitAction): OrbitSlice[] => [
  targetlessSlice('canvas-new-node', 'New node', NewNodeIcon, action),
  targetlessSlice('canvas-reflow', 'Reflow', ReflowIcon, action),
  targetlessSlice('canvas-bindings', 'Show all bindings', ShowAllBindingsIcon, action, true),
]
